/*
 * Gorilla Shed Costco Special Events
 * November and December 2026 events ending November 2 or later (excludes events ending November 1).
 * 14 events in 5 states | Street-only address field
 * Source: 2026 roadshow schedule originally compiled September 1, 2026
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gs-roadshow]');
  if (!root) return;

  var events = [
    {"address":"3901 W Costco DR","city":"Tucson","state":"AZ","stateName":"Arizona","zip":"85741","start":"2026-11-13","end":"2026-11-22","date":"Nov 13–22, 2026","search":"arizona az tucson 85741 3901 w costco dr"},
    {"address":"2030 N Imperial Ave","city":"El Centro","state":"CA","stateName":"California","zip":"92243","start":"2026-10-30","end":"2026-11-08","date":"Oct 30 – Nov 8, 2026","search":"california ca el centro 92243 2030 n imperial ave"},
    {"address":"9404 Central Ave","city":"Montclair","state":"CA","stateName":"California","zip":"91763","start":"2026-10-30","end":"2026-11-08","date":"Oct 30 – Nov 8, 2026","search":"california ca montclair 91763 9404 central ave"},
    {"address":"1900 Santa Rosa Ave","city":"Santa Rosa","state":"CA","stateName":"California","zip":"95407","start":"2026-10-30","end":"2026-11-08","date":"Oct 30 – Nov 8, 2026","search":"california ca santa rosa 95407 1900 santa rosa ave"},
    {"address":"1099 E Hospitality LN","city":"San Bernardino","state":"CA","stateName":"California","zip":"92408","start":"2026-11-06","end":"2026-11-15","date":"Nov 6–15, 2026","search":"california ca san bernardino 92408 1099 e hospitality ln"},
    {"address":"4900 Panama LN","city":"Bakersfield","state":"CA","stateName":"California","zip":"93313","start":"2026-11-13","end":"2026-11-22","date":"Nov 13–22, 2026","search":"california ca bakersfield 93313 4900 panama ln"},
    {"address":"280 Riversound Way","city":"Napa","state":"CA","stateName":"California","zip":"94558","start":"2026-11-20","end":"2026-11-29","date":"Nov 20–29, 2026","search":"california ca napa 94558 280 riversound way"},
    {"address":"2400 Monument Blvd","city":"Concord","state":"CA","stateName":"California","zip":"94520","start":"2026-11-27","end":"2026-12-06","date":"Nov 27 – Dec 6, 2026","search":"california ca concord 94520 2400 monument blvd"},
    {"address":"4805 Bechelli Ave","city":"Redding Ca","state":"CA","stateName":"California","zip":"96003","start":"2026-12-04","end":"2026-12-13","date":"Dec 4–13, 2026","search":"california ca redding ca 96003 4805 bechelli ave"},
    {"address":"355 E Neider Ave","city":"Coeur D' Alene","state":"ID","stateName":"Idaho","zip":"83815","start":"2026-11-13","end":"2026-11-22","date":"Nov 13–22, 2026","search":"idaho id coeur d' alene 83815 355 e neider ave"},
    {"address":"13130 SE 84TH Ave","city":"Clackamas","state":"OR","stateName":"Oregon","zip":"97015","start":"2026-11-13","end":"2026-11-22","date":"Nov 13–22, 2026","search":"oregon or clackamas 97015 13130 se 84th ave"},
    {"address":"198 N 1200 E","city":"Lehi","state":"UT","stateName":"Utah","zip":"84043","start":"2026-10-30","end":"2026-11-08","date":"Oct 30 – Nov 8, 2026","search":"utah ut lehi 84043 198 n 1200 e"},
    {"address":"835 N 3050 E","city":"Saint George","state":"UT","stateName":"Utah","zip":"84790","start":"2026-11-06","end":"2026-11-15","date":"Nov 6–15, 2026","search":"utah ut saint george 84790 835 n 3050 e"},
    {"address":"273 E 1000 N","city":"Spanish Fork","state":"UT","stateName":"Utah","zip":"84660","start":"2026-11-06","end":"2026-11-15","date":"Nov 6–15, 2026","search":"utah ut spanish fork 84660 273 e 1000 n"}
  ];

  root.innerHTML = [
    '<section class="gs-roadshow-events">',
      '<div class="gs-roadshow-inner">',
        '<div class="gs-roadshow-header">',
          '<h2>Find a Gorilla Shed Special Event Near You</h2>',
          '<p>Search by state, city, street address or ZIP code to find November and December 2026 Costco Special Events.</p>',
        '</div>',
        '<div class="gs-roadshow-controls" aria-label="Special event search filters">',
          '<label class="gs-roadshow-search-label" for="gs-roadshow-search">Search events</label>',
          '<input id="gs-roadshow-search" class="gs-roadshow-search" type="search" placeholder="Type a state, city, address or ZIP" autocomplete="off">',
          '<label class="gs-roadshow-state-label" for="gs-roadshow-state">Filter by state</label>',
          '<select id="gs-roadshow-state" class="gs-roadshow-state">',
            '<option value="">All states</option>',
          '</select>',
          '<button class="gs-roadshow-clear" type="button">Clear</button>',
        '</div>',
        '<div class="gs-roadshow-summary" aria-live="polite"></div>',
        '<div class="gs-roadshow-results"></div>',
      '</div>',
    '</section>'
  ].join('');

  var section = root.querySelector('.gs-roadshow-events');
  var searchInput = section.querySelector('.gs-roadshow-search');
  var stateSelect = section.querySelector('.gs-roadshow-state');
  var clearButton = section.querySelector('.gs-roadshow-clear');
  var summary = section.querySelector('.gs-roadshow-summary');
  var results = section.querySelector('.gs-roadshow-results');

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (match) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[match];
    });
  }

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function buildStateOptions() {
    var stateMap = {};

    events.forEach(function (event) {
      if (!stateMap[event.state]) {
        stateMap[event.state] = { name: event.stateName, count: 0 };
      }
      stateMap[event.state].count += 1;
    });

    Object.keys(stateMap)
      .sort(function (a, b) {
        return stateMap[a].name.localeCompare(stateMap[b].name);
      })
      .forEach(function (stateCode) {
        var option = document.createElement('option');
        option.value = stateCode;
        option.textContent = stateMap[stateCode].name + ' (' + stateMap[stateCode].count + ')';
        stateSelect.appendChild(option);
      });
  }

  function groupByState(items) {
    return items.reduce(function (groups, event) {
      if (!groups[event.state]) {
        groups[event.state] = {
          stateName: event.stateName,
          items: []
        };
      }
      groups[event.state].items.push(event);
      return groups;
    }, {});
  }

  function eventRow(event) {
    return [
      '<tr>',
        '<td data-label="Dates">' + escapeHtml(event.date) + '</td>',
        '<td data-label="Address">' + escapeHtml(event.address) + '</td>',
        '<td data-label="City">' + escapeHtml(event.city) + '</td>',
        '<td data-label="State">' + escapeHtml(event.state) + '</td>',
        '<td data-label="ZIP">' + escapeHtml(event.zip) + '</td>',
      '</tr>'
    ].join('');
  }

  function render() {
    var query = normalize(searchInput.value);
    var selectedState = stateSelect.value;

    var filtered = events.filter(function (event) {
      var matchesSearch = !query || normalize(event.search).indexOf(query) !== -1;
      var matchesState = !selectedState || event.state === selectedState;
      return matchesSearch && matchesState;
    });

    var grouped = groupByState(filtered);
    var stateCount = Object.keys(grouped).length;

    summary.textContent = 'Showing ' + filtered.length + ' event' +
      (filtered.length === 1 ? '' : 's') + ' in ' + stateCount + ' state' +
      (stateCount === 1 ? '' : 's') + '.';

    if (!filtered.length) {
      results.innerHTML = '<div class="gs-roadshow-empty">No special events matched your search. Try searching by state name, city, street address or ZIP code.</div>';
      return;
    }

    results.innerHTML = Object.keys(grouped)
      .sort(function (a, b) {
        return grouped[a].stateName.localeCompare(grouped[b].stateName);
      })
      .map(function (stateCode) {
        var group = grouped[stateCode];
        var rows = group.items.map(eventRow).join('');

        return [
          '<section class="gs-state-section" aria-label="' + escapeHtml(group.stateName) + ' special events">',
            '<div class="gs-state-heading">',
              '<h3>' + escapeHtml(group.stateName) + '</h3>',
              '<span class="gs-state-count">' + group.items.length + ' event' + (group.items.length === 1 ? '' : 's') + '</span>',
            '</div>',
            '<div class="gs-table-wrap">',
              '<table class="gs-roadshow-table">',
                '<thead>',
                  '<tr>',
                    '<th scope="col">Dates</th>',
                    '<th scope="col">Address</th>',
                    '<th scope="col">City</th>',
                    '<th scope="col">State</th>',
                    '<th scope="col">ZIP</th>',
                  '</tr>',
                '</thead>',
                '<tbody>' + rows + '</tbody>',
              '</table>',
            '</div>',
          '</section>'
        ].join('');
      })
      .join('');
  }

  buildStateOptions();
  render();

  searchInput.addEventListener('input', render);
  stateSelect.addEventListener('change', render);
  clearButton.addEventListener('click', function () {
    searchInput.value = '';
    stateSelect.value = '';
    render();
    searchInput.focus();
  });
})();
